import { ExternalLinkUrl } from 'config/shared/types/links';

import { APP_CONFIG } from '../../../../environment/app';

export const resolveExternalLinkUrl = (externalLinkUrl: ExternalLinkUrl): string => {
  return (
    externalLinkUrl[APP_CONFIG.environment as keyof ExternalLinkUrl] ||
    externalLinkUrl.default ||
    ''
  );
};
